// extracted by mini-css-extract-plugin
module.exports = {"banner":"bannerBlock_banner__aAHaz"};